import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signed',
  templateUrl: './signed.component.html',
  styleUrls: ['./signed.component.scss']
})
export class SignedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
